
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 20a1 1 0 01-1-1V1a1 1 0 011-1h14a1 1 0 011 1v3h-2V2H2v16h12v-2h2v3a1 1 0 01-1 1H1zm13-6v-3H7V9h7V6l5 4-5 4z","fill":"#FAAD14"}})])
          )
        }
      }
    